(function () {
	'use strict';

	/**
	 * @ngdoc component
	 *
	 * @name mx.shell:mxWizard
	 *
	 * @module mx.shell
	 *
	 * @requires {@ref mx.shell.EventService mx.shell.EventService}
	 * @requires $scope
	 *
	 * @description
	 * Directive that represents a wizard itself.
	 *
	 * @param {mx.shell.Wizard} wizard= - A wizard object that should be mapped to directive
	 * @param {function} onClose= - A function to be called after wizard is successfully finished or cancelled
	 *
	 * @usage <mx-wizard wizard="vm.thisWizard"></mx-wizard>
	 */

	angular.module('mx.shell').component('mxWizard', {
		transclude: true,
		bindings: {
			wizard: '=',
			toBeValidated: '@',
			isLazy: '<?',
			onClose: '=',
			wizardCustomHeader: '@',
		},
		controller: WizardController,
		controllerAs: 'vm',
		templateUrl: 'components/mx-wizard/mx-wizard.html',
	});

	WizardController.$inject = ['mx.internationalization', 'mx.shell.EventService', '$scope', 'mx.shell.KeyboardNavigationService', 'mx.shell.SideLayout', '$timeout'];

	function WizardController(i18n, eventService, $scope, keyboardNavigationService, sideLayout, $timeout) {
		var vm = this;

		vm.$onInit = function () {
			vm.isWideMode = sideLayout.fullScreenMode;
			vm.wizardInvalid = false;
			vm.isLazy = vm.isLazy || false;
			vm.wizard.pageIsInvalid = false;
			vm.validationState = {
				Validating: 1,
				Ok: 2,
				Failed: 3,
			};

			vm.__externalValidators = [];

			Object.defineProperty(vm, 'isReady', {
				get: function () {
					if (vm.isLazy === true && vm.wizard) {
						return Boolean(vm.wizard.isReady);
					}
					return true;
				},
			});

			Object.defineProperty(vm.wizard, 'wizardForm', {
				configurable: true,
				get: function () {
					return $scope.wizardForm;
				},
			});

			registerHotkeys();

			if (!vm.wizardCustomHeader) {
				var roadmapTitle = (vm.wizard.roadmap.title || '').trim();

				if (vm.wizard.contextDescription) {
					var link = '<a href="#" class="wizard-page--context-link">' + vm.wizard.contextDescription + '</a>';

					vm.wizardHeaderText = i18n.getFormatted('shell.wizard.headerTemplate', roadmapTitle, link);
				} else {
					vm.wizardHeaderText = i18n.getFormatted('shell.wizard.emptyHeaderTemplate', roadmapTitle);
				}
			} else {
				vm.wizardHeaderText = vm.wizardCustomHeader;
			}

			if (vm.toBeValidated === 'true') {
				vm.wizardState = vm.validationState.Validating;
				eventService.subscribeTo(
					mx.shell.EventCodes.ToggleWizardEnabled,
					function (e, state) {
						if (vm.wizard !== state.wizard) {
							return;
						}
						if (!state.enabled) {
							vm.wizardState = vm.validationState.Failed;
							vm.wizardInvalidMessage = state.message || i18n.get('shell.wizard.invalidDefaultMessage');
						} else {
							vm.wizardState = vm.validationState.Ok;
							vm.wizardInvalidMessage = '';
						}
					},
					$scope
				);
			} else {
				vm.wizardState = vm.validationState.Ok;
			}
		};

		$scope.$watchGroup(['vm.wizard.allWizardSteps.length', 'vm.wizard.currentStep'], updatePageTitleText);

		eventService.subscribeTo(
			mx.shell.EventCodes.SideLayoutWideModeSwitched,
			function (e, isWideMode) {
				vm.isWideMode = isWideMode && vm.wizard.allWizardPages.length > 1;
			},
			$scope
		);

		eventService.subscribeTo(
			mx.shell.EventCodes.WizardClose,
			function (e, data) {
				if (vm.wizard === data.wizard && vm.onClose && typeof vm.onClose === 'function') {
					vm.onClose();
				}
			},
			$scope
		);

		vm.goToPreviousPage = function () {
			var keys = Object.keys($scope.wizardForm);

			vm.wizard.goToPreviousPage();

			$timeout(function () {
				keys.forEach(function (key) {
					if ($scope.wizardForm[key] && $scope.wizardForm[key].$validate && !$scope.wizardForm[key].$valid) {
						delete $scope.wizardForm[key];
					}
				});

				$scope.wizardForm.$error = {};
				$scope.wizardForm.$invalid = false;
				$scope.wizardForm.$valid = true;
			});
		};

		vm.showContextDetails = function ($event) {
			var targetIsLink = (($event.target || {}).tagName || '').toLowerCase() === 'a';

			if (targetIsLink) {
				vm.wizard.displayContextFn();
			}
		};

		vm.externalValidatorsPass = function () {
			var isValid = true;
			vm.__externalValidators.forEach(function (validatingFn) {
				isValid = isValid === true ? validatingFn() : isValid;
			});
			return isValid;
		};

		function updatePageTitleText() {
			if (vm.wizard.allWizardPages.length > 1) {
				vm.pageTitleText = i18n.getFormatted('shell.wizard.pageTitleTemplate', vm.wizard.currentStep + 1, vm.wizard.allWizardSteps.length, vm.wizard.currentPage.title);
			}
		}

		function registerHotkeys() {
			keyboardNavigationService.registerKey([
				{
					scope: $scope,
					key: 'alt+>',
					nameInTemplate: 'nextHint',
					description: i18n.get('shell.mx-wizard.next'),
					callback: function () {
						if (vm.wizard.currentPage.buttons.next.isDisabled || $scope.wizardForm.$invalid) {
							return;
						}

						vm.wizard.goToNextPage();
					},
				},
				{
					scope: $scope,
					key: 'alt+<',
					nameInTemplate: 'previousHint',
					description: i18n.get('shell.mx-wizard.previous'),
					callback: function () {
						if (vm.wizard.currentPage.buttons.back.isDisabled) {
							return;
						}

						vm.wizard.goToPreviousPage();
					},
				},
				{
					scope: $scope,
					key: 'alt+c',
					nameInTemplate: 'cancelHint',
					description: i18n.get('shell.mx-wizard.cancel'),
					callback: function () {
						if (vm.wizard.currentPage.buttons.cancel && vm.wizard.currentPage.buttons.cancel.isDisabled) {
							return;
						}

						vm.wizard.cancelWizard();
					},
				},
				{
					scope: $scope,
					key: 'alt+s',
					nameInTemplate: 'finishHint',
					description: i18n.get('shell.mx-wizard.finish'),
					callback: function () {
						if (vm.wizard.currentPage.buttons.finish.isDisabled || $scope.wizardForm.$invalid) {
							return;
						}

						vm.wizard.finishWizard();
					},
				},
			]);
		}
	}
})();
